import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, AbstractControl } from '@angular/forms';
import {MatFormFieldAppearance, MatFormFieldModule} from '@angular/material/form-field';
import {ThemePalette} from '@angular/material/core';
import {MatInputModule} from '@angular/material/input';
import {ReactiveFormsModule} from '@angular/forms';

@Component({
    selector: 'xui-mat-textarea',
    templateUrl: './app-mat-text-area.component.html',
    styleUrls: ['./app-mat-text-area.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule]
})
export class AppMatTextAreaComponent {

  readonly appearance = input<MatFormFieldAppearance>('fill');
  readonly color = input<ThemePalette>('primary');
  readonly parentForm = input<UntypedFormGroup | undefined>();
  readonly name = input('');
  readonly label = input('');
  readonly placeholder = input('');
  readonly helpText = input('');
  readonly readonly = input(false);
  readonly rows = input(3);
  readonly errorMessage = input('');
  private get element(): UntypedFormControl | null {
        const parentForm = this.parentForm();
        const name = this.name();
        if (!parentForm || !name) {
            return null;
        }
        return parentForm.get(name) as UntypedFormControl | null;
    }

    get fieldValid(): boolean {
        const element = this.element;
        if (!element || !this.required || this.readonly()) { return true; }
        return !element.invalid && (element.dirty || element.touched);
    }

    get required(): boolean {
        const element = this.element;
        const validator = element?.validator ? element.validator({} as AbstractControl) : null;
        return !!(validator && validator.required);
    }

    get invalid(): boolean {
        return this.element?.invalid ?? false;
    }
    get shouldValidate(): boolean {
        const element = this.element;
        return element?.touched || element?.dirty || false;
    }

    blur(event: any) {
    }
}
